/**
 * Get Billing configuration
 * @param {String} billing - User's billing info
 * @return {Boolean} - True if valid or false if not valid
 * @public
 */
export function getMopPaymentMethodFromBilling(billing) {
  return (
    billing &&
    billing.subscriptions &&
    billing.subscriptions.length &&
    billing.subscriptions[0].info &&
    billing.subscriptions[0].info.length &&
    billing.subscriptions[0].info[0]
  );
}
